import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../../User/Link/UserLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './Subjects.scss';
export var Subjects = function (_a) {
    var className = _a.className, subjectTags = _a.subjectTags, locationTag = _a.locationTag;
    var t = useTranslation().t;
    if ((!subjectTags || !subjectTags.length) && !locationTag) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        subjectTags &&
            subjectTags.map(function (subject) { return (React.createElement("span", { key: subject.name, className: s['subject'] },
                React.createElement("span", { className: s['subject-title'] }, t("deviation.subject.".concat(subject.type))),
                "\u00A0\u00A0",
                subject.user && React.createElement(UserLink, { user: subject.user }),
                !subject.user && (React.createElement(BiLink, { className: s['subject-name'], href: subject.url, biData: {
                        evid: BiEventType.SUBJECT_CLICK,
                        subject_name: subject.name,
                        subject_type: subject.type,
                    } }, subject.name)))); }),
        locationTag && (React.createElement("span", { className: s['subject'] },
            React.createElement("span", { className: s['subject-title'] }, t('deviation.subject.location')),
            "\u00A0\u00A0",
            React.createElement(BiLink, { className: s['subject-name'], href: locationTag.url, biData: {
                    evid: BiEventType.LOCATION_CLICK,
                    location_name: locationTag.name,
                } }, locationTag.name)))));
};
Subjects.displayName = 'Subjects';
export default Subjects;
//# sourceMappingURL=Subjects.js.map